<div class="tagRatingDs__cont tagRatingDs__cont--{{size}}">
  <div class="tagRatingDs__score">
    <div class="tagRatingDs__score-tag tagRatingDs__score-tag--{{size}}">
      <app-ds-typography
        [text]="tagLabel"
        [size]="scoreFontSize"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Invert">
      </app-ds-typography>
    </div>
    <ng-container *ngIf="scoreRangeIsEnabled">
      <div class="tagRatingDs__score-range">
        <app-ds-typography
          [text]="range"
          [size]="rangeFontSize"
          [color]="fontColor.Secondary">
        </app-ds-typography>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="infoIsEnabled">
    <div class="tagRatingDs__info tagRatingDs__info--{{size}}">
      <ng-container *ngIf="titleIsEnabled">
        <div class="tagRatingDs__info-title">
          <app-ds-typography
            [text]="title"
            [size]="titleFontSize"
            [fontFamily]="fontFamily.SemiBold"
            [color]="fontColor.Primary">
          </app-ds-typography>
        </div>
      </ng-container>
      <ng-container *ngIf="descriptionIsEnabled">
        <div class="tagRatingDs__info-description">
          <app-ds-typography
            [text]="description"
            [size]="descriptionFontSize"
            [color]="fontColor.Primary"
            [tag]="'q'">
          </app-ds-typography>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>